import { render } from "./StandingsSunC.vue?vue&type=template&id=6143c7f0&scoped=true"
import script from "./StandingsSunC.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsSunC.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsSunC.vue?vue&type=style&index=0&id=6143c7f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6143c7f0"]])

export default __exports__